import { render, staticRenderFns } from "./TableListTaxesPending.vue?vue&type=template&id=5bbc2ef6&"
import script from "./TableListTaxesPending.vue?vue&type=script&lang=js&"
export * from "./TableListTaxesPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports